export default __webpack_public_path__ + "static/IcebarSmoothie-b16a94be3608a5d94be134f3a841f5e9.mp4";